<template>
  <div>
    <transition name="slide-y-transition" appear>
      <filing-tabs v-show="stepsVisible" class="mb-5"/>
    </transition>

    <workflow-wrapper>
      <party-tab v-if="selectedStepID === CONST.FILING_STEP_PARTIES"
                 :key="`partyTab-${tabNonce}`"
                 @next="next"/>
      <filing-info-tab v-if="selectedStepID === CONST.FILING_STEP_FILING_INFO"
                       :key="`filingInfoTab-${tabNonce}`"
                       @next="next"/>
      <orig-court-tab v-if="selectedStepID === CONST.FILING_STEP_ORIGINATING_COURT"
                      :key="`originatingCourtTab-${tabNonce}`"
                      @next="next"/>
      <docket-entry-tab v-if="selectedStepID === CONST.FILING_STEP_DOCKET_ENTRIES"
                        :key="`docketEntryTab-${tabNonce}`"
                        @next="next"/>
      <service-tab v-if="selectedStepID === CONST.FILING_STEP_SERVICE"
                   :key="`serviceTab-${tabNonce}`"
                   @next="next"/>
      <summary-tab v-if="selectedStepID === CONST.FILING_STEP_SUMMARY"
                   :key="`summaryTab-${tabNonce}`"
                   @submitFiling="$emit('submitFiling')"/>
    </workflow-wrapper>

  </div>
</template>

<script>
import WorkflowWrapper from '@components/support/WorkflowWrapper';
import PartyTab from '@components/support/manageFiling/PartyTab';
import FilingInfoTab from '@components/support/manageFiling/FilingInfoTab';
import DocketEntryTab from '@components/support/manageFiling/DocketEntryTab';
import ServiceTab from '@components/support/manageFiling/ServiceTab';
import SummaryTab from '@components/support/manageFiling/SummaryTab';
import FilingTabs from '@components/support/manageFiling/FilingTabs';
import { useFilingStore } from '@/stores/filingStore';
import OrigCourtTab from '@components/support/manageFiling/OrigCourtTab';

const filingStore = useFilingStore();

export default {
  components: { OrigCourtTab, PartyTab, WorkflowWrapper, FilingTabs, FilingInfoTab, DocketEntryTab, ServiceTab, SummaryTab },
  computed: {
    stepsVisible () {
      return filingStore.stepsVisible;
    },
    selectedStepID () {
      return filingStore.getSelectedStepID;
    },
    tabNonce () {
      return filingStore.tabNonce;
    }
  },
  methods: {
    next () {
      filingStore.nextStep();
    }
  }
};
</script>